/** Entry IDs that are referenced from the code directly and
 * expected to be always defined */
export enum StaticContentfulEntry {
  /** Contract Contentful page entry */
  CONTRACT_PAGE = '6XR0bc1u4lGLoRvR56trdd',
  /** Contentful entry id for MessageCategories entry */
  NEW_MESSAGE_PAGE = '4bVgFjN3PPtO94AmGf1V8c',
  /** My home Contentful page entry */
  APARTMENT_PAGE = '1wVGYIxTaYyeTeUTiHz6Ci',
  /** Real estate and common spaces Contentful page entry */
  REAL_ESTATE_AND_COMMON_SPACES_PAGE = 'hmxwf5U5kVEgYDhCGVPWt',
  /** Contentful entry id for max sauna shifts StaticNotification */
  MAX_SAUNA_SHIFTS_NOTIFICATION = '24RTBAcg09IHy3PqGoEsnx',
  /** Contentful entry id for a common form used by all apartment defects */
  APARTMENT_ACCESS_COMMON_FORM = '6XiB2HfvOj6KN14BQmukOq',
  /** Contentful entry id for appliance defect instructions modal */
  APPLIANCE_DEFECT_MODAL = 'aorwWvSxDduBox5TvbZ9o',
  /** Contentful entry id for Footer entry */
  FOOTER = 'E3aZ5qHx89TRlXfhmpkr1',
  /** Parking space apartment page info */
  PARKING_SPACE_INFO = '53JUXxc0f8oylCGbEQb7Iq',
  DRYING_ROOM_INFO = '4EC40VNGza3xLHrJUMCiFY',
  STORAGE_SPACE_INFO = '2J14RAi7agE1wCTkk6e1DO',
  BABY_CARRIAGE_STORAGE_INFO = '4BxO0DRvSpfbYFHib8n4jE',
  OUTDOOR_STORAGE_INFO = 'DD4kCjlMe1VmhJ393DAnX',
  SHELTER_INFO = '2dMgvW8aCeuUlSVa6BXxnp',
  /** Info text displayed when disturbance report form for smoking is being filled */
  SMOKING_DISTURBANCE_REASON_INFO = '5FCe4y6Ryck5NBeCDwbaAr',
  PARCEL_MACHINE_INFO = 'aF66z2zHBDa45mUEgbAMj',
  TOLOTRACK_DESCRIPTION = '3BdHn5o1GNMMtzMu28tagr',
  PROTEGUS_2_DESCRIPTION = 'z9aPcYgTQlNucRdI68rwr',
  CELOTRON_DESCRIPTION = '22lQWEYDdx9mLXday8wjgB',
  TOLOGO_DESCRIPTION = '1jWC8rh3gdAt5YcPUB9uT1',
}
